/* Version: 3.5.149 */
'use client';
import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

var checkmarkIcon = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    focusable: "false",
    viewBox: "0 0 20 20",
    children: [/*#__PURE__*/jsx("title", {
      children: alt
    }), /*#__PURE__*/jsx("path", {
      fill: "none",
      fillRule: "nonzero",
      d: "M16.667 0L11.11 5.49 7.222 9.333 3.333 5.49 0 8.863 7.222 16l7.222-7.137L20 3.373z"
    })]
  });
});

export { checkmarkIcon as default };
